import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// --- LCP optimization: make the hero image discoverable in the initial document ---
// Injected synchronously at the very top of <head>, before any tracking or render,
// so the browser starts the connections + hero image download as early as possible.
if (typeof document !== 'undefined' && !(window as any).__lcpHintsInjected) {
  ;
  (window as any).__lcpHintsInjected = true;
  const head = document.head;
  const firstChild = head.firstChild;
  const addLink = (rel: string, href: string, attrs: Record<string, string> = {}) => {
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
    head.insertBefore(link, firstChild);
  };
  // Preload the exact hero LCP image at high priority (first, so it sits highest in <head>)
  addLink('preload', 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/ebook_430x.webp?v=1780543244', {
    as: 'image',
    type: 'image/webp',
    fetchpriority: 'high'
  });
  // Preconnect to critical origins
  addLink('preconnect', 'https://cdn.shopify.com');
  addLink('preconnect', 'https://cdn.magicpatterns.com');
  addLink('preconnect', 'https://fonts.googleapis.com');
  addLink('preconnect', 'https://fonts.gstatic.com', {
    crossorigin: 'anonymous'
  });
}
// Meta Pixel — runs once before React mounts
if (typeof window !== 'undefined' && !(window as any).__fbPixelInitialized) {
  ;
  (window as any).__fbPixelInitialized = true;
  !function (f: any, b: any, e: any, v: any) {
    var n: any, t: any, s: any;
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  (window as any).fbq('init', '26253120474284322');
  (window as any).fbq('track', 'PageView');
} // Microsoft Clarity
;
(function (c: any, l: Document, a: string, r: string, i: string, t?: HTMLScriptElement, y?: Element) {
  c[a] = c[a] || function () {
    ;
    (c[a].q = c[a].q || []).push(arguments);
  };
  t = l.createElement(r) as HTMLScriptElement;
  t.async = true;
  t.src = 'https://www.clarity.ms/tag/' + i;
  y = l.getElementsByTagName(r)[0];
  y.parentNode?.insertBefore(t, y);
})(window, document, 'clarity', 'script', 'wvr6e8pc8j');
render(<App data-id="element-236" />, document.getElementById('root'));